import UsageMonitoring from '@/services/UsageMonitoring';
import SpecialistKeepAlive from '@/services/SpecialistKeepAlive';
import ZendeskConfig from '@/services/Zendesk';

function Watchers(store) {
  const zendeskConfig = ZendeskConfig();

  store.watch(
    (state, getters) => getters['dashboard/currWorkspace'],

    workspace => {
      if (!workspace) return;

      zendeskConfig.init(workspace);

      if (workspace.isDoctor) {
        store.dispatch('app/verifyMemedAuth');
        store.dispatch('callListener/init');
      }

      if (workspace.isSpecialist) {
        SpecialistKeepAlive.init();
      } else {
        SpecialistKeepAlive.stop();
      }
    },
  );

  store.watch(
    (state, getters) => getters['auth/isProfessionalRedeConexa'],

    isProfessionalRedeConexa => {
      if (isProfessionalRedeConexa) {
        UsageMonitoring.init();
      } else {
        UsageMonitoring.stop();
      }
    },
  );

  store.watch(
    ({ auth }) => auth.userServiceProfile,

    userServiceProfile => {
      zendeskConfig.addServiceProfileTags(userServiceProfile);
    },
  );
}

export default Watchers;
